import { Link } from "react-router-dom";
import logo from "../assets/images/LWSBlog.svg";

export default function NavBar() {
    return (
        <nav className="py-4 border-b">
            <div className="navbar-container">
                <div className="logo">
                    <Link to="/"> <img src={logo} alt="search" /> </Link>
                </div>
                <div className="auth-buttons">
                    <button className="btn btn-primary">Sign In</button>
                    <button className="btn btn-outline">Sign Up</button>
                </div>
            </div>
        </nav>
    );
}
